/**
 * Structural value-equality for FD UPDATE no-op detection.
 * Handles bigint/number, Date/ISO-string, and null/undefined cross-representation.
 * Does NOT recurse: FD item shapes are flat scalars.
 */
export function fdFieldValuesEqual(a: unknown, b: unknown): boolean {
  if (a === b) return true;
  if (a == null && b == null) return true;
  if (a == null || b == null) return false;

  if (typeof a === "bigint" && typeof b === "bigint") return a === b;
  if (typeof a === "bigint" && typeof b === "number") {
    return Number.isInteger(b) && a === BigInt(b);
  }
  if (typeof a === "number" && typeof b === "bigint") {
    return Number.isInteger(a) && BigInt(a) === b;
  }

  if (a instanceof Date && b instanceof Date) {
    return a.getTime() === b.getTime();
  }
  if (a instanceof Date && typeof b === "string") {
    return a.toISOString() === b;
  }
  if (typeof a === "string" && b instanceof Date) {
    return a === b.toISOString();
  }

  return false;
}

/** True when every field in `proposed` matches `existing` (per `fdFieldValuesEqual`). Skips existing-only keys. */
export function isFDItemUpdateNoOp(
  proposed: object,
  existing: object,
): boolean {
  for (const [key, value] of Object.entries(proposed)) {
    if (!fdFieldValuesEqual(value, Reflect.get(existing, key))) return false;
  }
  return true;
}
